import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateFnsModule } from 'ngx-date-fns';

@NgModule({
  declarations: [],
  imports: [CommonModule, DateFnsModule],
  exports: [DateFnsModule],
})
export class CoreModule {}
